import { supabase } from './supabase';

export async function getOrCreateCompany(user) {
  const { data: existing } = await supabase
    .from('companies')
    .select('*')
    .eq('owner_id', user.id)
    .maybeSingle();

  if (existing) return existing;

  const restaurantName = user.user_metadata?.restaurant_name || 'My Restaurant';
  const { data: created } = await supabase
    .from('companies')
    .insert([{
      name: restaurantName,
      owner_id: user.id,
      owner_email: user.email,
      industry: 'restaurant',
      target_labor: 25,
    }])
    .select()
    .single();

  return created;
}